import { render } from "./NotifyPhonesList.vue?vue&type=template&id=2978a736&scoped=true"
import script from "./NotifyPhonesList.vue?vue&type=script&lang=js"
export * from "./NotifyPhonesList.vue?vue&type=script&lang=js"

import "./NotifyPhonesList.vue?vue&type=style&index=0&id=2978a736&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2978a736"]])

export default __exports__